import { hideProp } from "../../../tools/hideProp";
import { createMeta } from "./StateMeta";
import WujiTips from "../../../tools/wujiTips";
export function Action(actionName, def) {
  return function (target, methodName, desc) {
    if (typeof desc.value !== 'function') {
      throw new Error(`[Action] ${methodName} is not a function`);
    }
    const ctor = target.constructor;
    const meta = createMeta(ctor);
    const actionInfo = {
      actionName,
      methodName,
      def
    };
    meta.registerAction(actionInfo);
    const actionMethod = createActionMethod(desc.value, actionInfo);
    desc.value = actionMethod;
    return desc;
  };
}
/**
 * 给用户自定义cgi使用
 * @param state
 * @param action
 * @returns
 */
export function createAction(state, action) {
  const {
    methodName
  } = action;
  const method = state[action.methodName];
  if (typeof method !== 'function') {
    console.error(`[createAction] ${methodName} is not a function`);
    return;
  }
  const actionMethod = createActionMethod(method, action);
  hideProp(state, methodName, {
    value: actionMethod,
    enumerable: false,
    writable: false
  });
}
export function createActionMethod(method, action) {
  const {
    actionName,
    def
  } = action;
  const actionMethod = async function (...args) {
    const wujiTips = new WujiTips();
    try {
      const cgis = def.cgiDeps || [];
      const cgisUnset = cgis.filter(name => !this.getCgiSupported(name));
      if (cgis.length && cgisUnset.length) {
        // 这样有一个cgi不支持就不需要调用了
        const res = {
          success: false,
          message: `[${actionName}]数据源方法依赖的接口 [${cgisUnset.join(' / ')}] 未配置`
        };
        wujiTips.error({
          content: res.message
        });
        return res;
      }
      this.loading = true;
      const res = await method.apply(this, args);
      return res;
    } catch (error) {
      const msg = `[${actionName}]数据源方法执行失败: ${error.message}`;
      this.errorMessage = msg;
      console.error(error);
      wujiTips.error({
        content: msg
      });
    } finally {
      this.loading = false;
    }
  };
  return actionMethod;
}
//# sourceMappingURL=Action.js.map
